import classnames from 'classnames'
import React, { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { selectCurrentHistoryFullRoute } from '../../store/history/history.selectors'
import s from './TextCssShortener.less'

const DEFAULT_EXPAND_BUTTON_LABEL = 'En savoir plus'

const TextCssShortener = ({ className, children, expandButtonLabel = DEFAULT_EXPAND_BUTTON_LABEL }) => {
  const [short, setShort] = useState(true)

  useShortenOnRouteChange(setShort)

  const expand = useCallback(() => setShort(false))

  return (
    <div className={s.root}>
      <div className={classnames(className, s.text, short && s.short)}>{children}</div>
      {short && (
        <div className={s.more}>
          <button className={s.moreButton} onClick={expand}>
            {expandButtonLabel}
          </button>
        </div>
      )}
    </div>
  )
}
const useShortenOnRouteChange = setShort => {
  const fullRoute = useSelector(selectCurrentHistoryFullRoute)

  useEffect(() => setShort(true), [fullRoute, setShort])
}

export default TextCssShortener
